import React from "react";
import { createRoot } from "react-dom/client"; // Import createRoot
import App from "./App";
import { ChakraProvider1 } from "../src/components/ui/provider";
import { store } from "./app/store";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement); // Create a root

root.render(
  // Use the render method of the root object
  <React.StrictMode>
    {/* <HashRouter> */}
    <BrowserRouter>
      <Provider store={store}>
        <ChakraProvider1>
          <App />
        </ChakraProvider1>
      </Provider>
    </BrowserRouter>
    {/* </HashRouter> */}
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
